import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function ArrowUpIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'Grey6', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.777 12.865l-5.25-4.667A.767.767 0 0012 8a.767.767 0 00-.527.198l-5.25 4.667a.608.608 0 00-.223.468c0 .18.074.337.223.469A.768.768 0 006.75 14h10.5a.768.768 0 00.527-.198.608.608 0 00.223-.469.608.608 0 00-.223-.468z", fill: primaryFillColor }) }));
}
//# sourceMappingURL=ArrowUp.js.map